/* @flow */
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import GroupLeaveConfirmDialog from './GroupLeaveConfirmDialog';
import Dialog from 'components/Dialog';
import { FormattedMessage } from 'react-intl';
import Group from 'entities/Group';
import ModalTrigger from 'components/ModalTrigger';
import PropTypes from 'prop-types';
import * as React from 'react';
import GroupName from 'groups/components/GroupName';
import './styles/GroupSubscribedSettingModal.scss';

class GroupSubscribedSettingModal extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    group: PropTypes.instanceOf(Group).isRequired,
  };

  renderConfirmModal = () => {
    return (
      <GroupLeaveConfirmDialog
        group={this.props.group}
        onLeave={() => this.props.onRequestHide()}
      />
    );
  };

  render() {
    const { group } = this.props;
    const ownerNames = group.getOwners().map(o => o.getUser().getName());
    const groupName = <GroupName group={group} />;

    const leaveButtonOpt = group.canLeave() && (
      <div className="GroupSubscribedSettingModal-actionBox">
        <ModalTrigger modal={this.renderConfirmModal()}>
          <Button data-test-selector="leave_class_button" size="small" level="text" color="lava">
            Leave this class
          </Button>
        </ModalTrigger>
        <p>You will no longer receive announcements from {groupName}.</p>
      </div>
    );

    return (
      <Dialog
        eventScreenName="GroupSubscribedSettingModal"
        {...this.props}
        size="small"
        title="Class settings"
        className="GroupSubscribedSettingModal">
        <BoxBody divided>
          <div>
            <div>
              <div className="GroupSubscribedSettingModal-info-header">Class name</div>
              <div className="GroupSubscribedSettingModal-info-content">{groupName}</div>
            </div>
            <div>
              <div className="GroupSubscribedSettingModal-info-header">Class code</div>
              <div className="GroupSubscribedSettingModal-info-content">
                @{group.getCodeOrError()}
              </div>
            </div>
            <div>
              <div className="GroupSubscribedSettingModal-info-header">
                <FormattedMessage
                  className="GroupSubscribedSettingModal-info-header"
                  id="groupSchoolDialog.title"
                  defaultMessage="{ownerNum, plural, one {Owner} other {Owners}}"
                  values={{ ownerNum: ownerNames.length }}
                />
              </div>
              <div className="GroupSubscribedSettingModal-info-content">
                {ownerNames.join(', ')}
              </div>
            </div>
          </div>
          {leaveButtonOpt}
        </BoxBody>
      </Dialog>
    );
  }
}

export default GroupSubscribedSettingModal;
